import { useState } from 'react';
import Add from '@mui/icons-material/Add';
import SwapVert from '@mui/icons-material/SwapVert';

import { Button, Stack } from '@mui/material';
import { useScreenSizes } from '@/hooks/use-screen-sizes';
import { ReorderBlocksDialog } from '@/packages/learning-path/pages/path-management/pages/edit-path/components/reorder-blocks-dialog';
import { useManagePath } from '@/packages/learning-path/pages/path-management/pages/edit-path/context';

export const ActionButtons = () => {
  const { addTextBlock, addResourcesBlock, contents } = useManagePath();
  const { isSmallScreen } = useScreenSizes();
  const [reorderBlocksDialogOpen, setReorderBlocksDialogOpen] = useState<
    boolean | null
  >(null);

  return (
    <Stack
      direction={isSmallScreen ? 'column' : 'row'}
      sx={{ width: isSmallScreen ? '100%' : 'auto', mt: 1 }}
      spacing={1}
    >
      <Button variant="outlined" startIcon={<Add />} onClick={addTextBlock}>
        Adicionar texto
      </Button>
      <Button
        variant="outlined"
        onClick={addResourcesBlock}
        startIcon={<Add />}
      >
        Adicionar recurso
      </Button>
      <Button
        variant="outlined"
        startIcon={<SwapVert />}
        onClick={() => setReorderBlocksDialogOpen(true)}
        disabled={contents.length <= 1}
      >
        Reordenar seções
      </Button>
      {reorderBlocksDialogOpen && (
        <ReorderBlocksDialog onClose={() => setReorderBlocksDialogOpen(null)} />
      )}
    </Stack>
  );
};
